const getters = {
    andirodData: state => state.settings.andirodData
    // errorLogs: state => state.errorLog.logs
};
export default getters;
